import Cookies from 'js-cookie';
import { pageLoaded, $ } from 'venuescanner-js/tools/elemental';

const key = 'accept-cookies';
pageLoaded(() => {
  const isCookieSet = Cookies.get(key);

  if (!isCookieSet) {
    const cookieContainer = $('.ux-cookies');
    cookieContainer.show();

    cookieContainer.find('button.js-btn').click(() => {
      Cookies.set(key, true, { expires: 365 });
      cookieContainer.hide();
    });
  }
});
